import { ReactElement } from 'react';

import {
   ConfidentialityMode,
   PractitionerUpdateConfidentialityModeCommand,
} from '@dreryk/egabinet-personnel-frontend-api';
import { PractitionerId } from '@dreryk/egabinet-personnel-published-language-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { dispatchSnackbarPositiveEvent, ModalConfirmButton } from '@dreryk/react-components';

import { useGetCurrentPractitionerGlobalState, useRefetchCurrentPractitioner } from '~libs.shared.account';

import { practitionersTranslationKeys } from '../../../../../../../translations';
import { DefaultConfidentialityModeUpdateFormController } from '../form/DefaultConfidentialityModeUpdateForm.types';

type DefaultConfidentialityModeNonHistoricalUpdateModalConfirmButtonProps = Pick<
   DefaultConfidentialityModeUpdateFormController,
   'handleSubmit'
> & {
   readonly mode: ConfidentialityMode;
   readonly practitionerId: number;
   readonly onSuccess: VoidFunction;
};

export const DefaultConfidentialityModeNonHistoricalUpdateModalConfirmButton = (
   props: DefaultConfidentialityModeNonHistoricalUpdateModalConfirmButtonProps
): ReactElement => {
   const currentPractitioner = useGetCurrentPractitionerGlobalState();
   const refetchCurrentPractitioner = useRefetchCurrentPractitioner();

   const { executeAsync: updateConfidentialityMode } = useCqrsCommand<void, void>(
      () => {
         const command = new PractitionerUpdateConfidentialityModeCommand();
         command.id = PractitionerId.of(props.practitionerId);
         command.mode = props.mode;
         return command;
      },
      {
         onSuccess: () => {
            dispatchSnackbarPositiveEvent(practitionersTranslationKeys.defaultConfidentialResourceModeUpdate.saved);

            if (currentPractitioner.id === props.practitionerId) {
               refetchCurrentPractitioner();
            }

            props.onSuccess();
         },
      }
   );

   return (
      <ModalConfirmButton
         label={commonTranslationKeys.save}
         onClick={props.handleSubmit(async () => updateConfidentialityMode())}
      />
   );
};
